import api from './api';


const profileService = {
  getProfile: async ({ user_id, signal } = {}) => {
    const response = await api.get('/users/profile', {
      params: user_id ? { user_id } : undefined,
      signal,
    });
    return response.data;
  },

  upsertBaseProfile: async (payload, signal) => {
    const response = await api.post('/users/profile/base/', payload, { signal });
    return response.data;
  },

  getInvestorProfile: async ({ signal } = {}) => {
    const response = await api.get('/users/profile/investor/', { signal });
    return response.data;
  },

  getTraderProfile: async ({ signal } = {}) => {
    const response = await api.get('/users/profile/trader/', { signal });
    return response.data;
  },

  changePassword: async (payload, signal) => {
    const response = await api.post('/users/profile/security/password/', payload, { signal });
    return response.data;
  },

  getTwoFactorStatus: async ({ signal } = {}) => {
    const response = await api.get('/users/profile/security/2fa/', { signal });
    return response.data;
  },

  startTwoFactorSetup: async (signal) => {
    const response = await api.post('/users/profile/security/2fa/setup/', {}, { signal });
    return response.data;
  },

  enableTwoFactor: async (payload, signal) => {
    const response = await api.post('/users/profile/security/2fa/enable/', payload, { signal });
    return response.data;
  },

  disableTwoFactor: async (payload, signal) => {
    const response = await api.post('/users/profile/security/2fa/disable/', payload, { signal });
    return response.data;
  },

  getApiKeys: async ({ signal } = {}) => {
    const response = await api.get('/users/profile/security/api-keys/', { signal });
    return response.data;
  },

  createApiKeys: async (payload, signal) => {
    const response = await api.post('/users/profile/security/api-keys/', payload, { signal });
    return response.data;
  },

  deleteApiKeys: async (payload, signal) => {
    const response = await api.delete('/users/profile/security/api-keys/', {
      data: payload,
      signal,
    });
    return response.data;
  },
};

export default profileService;
